// $('.swatch-element').on('click', function() {
//     var selectedVariant = $('.variant-selection__variants .selected');
//     if (selectedVariant.length) {
//         var dataTypeAttr = selectedVariant.data('type-attr');
//         console.log(dataTypeAttr);
//     }
// });

const sliderThumbs = new Swiper(".slider__thumbs .swiper-container", {
    direction: "vertical",
    slidesPerView: 5,
    // spaceBetween: 24, 
    navigation: {
        nextEl: ".slider__next",
        prevEl: ".slider__prev"
    },
    freeMode: true,
    breakpoints: {
        0: {
            direction: "horizontal"
        },
        768: {
            direction: "vertical",
            on: {
                slideChange: function() {
                    const slides = this.slides;

                    slides.forEach((slide) => {
                        const video = slide.querySelector('video');
                        if (video) {
                            video.pause();
                        }
                    });

                    const activeSlide = slides[this.activeIndex];
                    const activeVideo = activeSlide.querySelector('video');
                    if (activeVideo) {
                        activeVideo.currentTime = 0;
                        activeVideo.play();
                    }
                },
            },
        }
    }
});


const sliderImages = new Swiper(".slider__images .swiper-container", {
    direction: "vertical",
    slidesPerView: 1,
    // spaceBetween: 32, 
    mousewheel: true,
    navigation: {
        nextEl: ".slider__next",
        prevEl: ".slider__prev"
    },
    grabCursor: true,
    thumbs: {
        swiper: sliderThumbs
    },
    breakpoints: {
        0: {
            direction: "horizontal"
        },
        768: {
            direction: "vertical",
            on: {
                slideChange: function() {
                    const slides = this.slides;

                    slides.forEach((slide) => {
                        const video = slide.querySelector('video');
                        if (video) {
                            video.pause();
                        }
                    });

                    const activeSlide = slides[this.activeIndex];
                    const activeVideo = activeSlide.querySelector('video');
                    if (activeVideo) {
                        activeVideo.currentTime = 0;
                        activeVideo.play();
                    }
                },
            },
        }
    }
});


function setSliderHeight() {
    const sliderImagesContainer = document.querySelector('.slider__images .swiper-container');
    if (window.innerWidth >= 768) {
        sliderImagesContainer.style.height = `${window.innerHeight * 0.9}px`;
    } else {
        sliderImagesContainer.style.height = 'auto';
    }
}


setSliderHeight();
window.addEventListener('resize', setSliderHeight);


$(document).on('click', '.j1q-N', function () {
  $('.cutmStaxtx').toggleClass('active');

  var $this = $(this);
  $this.toggleClass('SeeMore2');

  if ($this.hasClass('SeeMore2')) {
    $this.text('Show less...');
  } else {
    $this.text('Show more...');
  }
});

$(document).ready(function() {

    $(document).on('click', '.swatch__option label', function() {
        $(this).find('.tooltipData').show().parents('.swatch__option').siblings('.swatch__option').find('.tooltipData').hide()
    });



    // $(".j1q-N").click(function() {
    //     $(".cutmStaxtx").toggleClass("active");
    // });

    // $('.j1q-N').click(function() {
    //     var $this = $(this);
    //     $this.toggleClass('SeeMore2');
    //     if ($this.hasClass('SeeMore2')) {
    //         $this.text('Show more...');
    //     } else {
    //         $this.text('Show less...');
    //     }
    // });

    $(document).on('click', '[JSUpsellsCart]', function(e) {
        e.preventDefault();
        var mainObjj = $(this),
            dataProductId = $(this).parents('.product-block-additional-product').attr('data-productghPdp');
        $(this).attr('checked', true)
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            method: 'Post',
            data: {
                id: $(this).val(),
                quantity: 1
            },
            success: function() {
                $.ajax({
                    url: '/cart.js',
                    dataType: 'json',
                    success: function(cart) {
                        cart.items.forEach(function(item) {
                            if (dataProductId == item.product_id) {
                                $('.product-block-additional-product[data-productghPdp="' + dataProductId + '"]').addClass('hide');
                            }
                        })
                        mainObjj.attr('checked', true);
                        var itemsCount = cart.item_count;
                        $('.header-cart').addClass('has-cart-count');
                        $('.header-cart__count').html(itemsCount);
                        $('.header-cart__icon').addClass('has-cart-count');
                        $('.header-cart__count').html(itemsCount);
                    }
                });
            }
        });
    });

    document.addEventListener('UPEZ__CART_REFETCHED_AFTER_CHANGE', (e) => {
        const cart = e.detail.cart;
        const getCartItem = [];
        if (cart.item_count > 0) {
            cart.items.forEach(function(item) {
                getCartItem.push(item.product_id);
            })
        } else {
            document.querySelectorAll('.product-block-additional-product').forEach((elm) => {
                elm.classList.remove('hide')
            });
        }
        document.querySelectorAll('.product-block-additional-product').forEach((elm) => {
            var checkElm = parseInt(elm.getAttribute('data-productghpdp'));
            if (getCartItem.indexOf(checkElm) !== -1) {
                console.log(checkElm);
                elm.classList.add('hide');
            } else {
                elm.classList.remove('hide')
            }
        });
    });
    document.querySelectorAll('.tab-link').forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            document.querySelectorAll('.tab-link').forEach(function(tab) {
                tab.parentNode.classList.remove('active');
            });
            this.parentNode.classList.add('active');
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            $(targetId).children('.detailsDescrips').slideDown().parent('.tab-content').addClass('active').siblings('.tab-content').removeClass('active').children('.detailsDescrips').slideUp();
            targetElement.parentNode.scrollIntoView({
                behavior: 'smooth'
            });
        });
    });

    $(document).on('click', '.detailsDescripss', function(e) {
        e.preventDefault();
        $(this).siblings('.detailsDescrips').slideToggle().parent('.tab-content').toggleClass('active').siblings('.tab-content').removeClass('active').children('.detailsDescrips').slideUp();
    });

});




